import { ButtonProps, ListItemText } from "@mui/material"
import { ReactNode, useState } from "react"
import { Button, FormControl, MenuItem } from "src/components"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Menu from "src/components/Menu";
import ListItemIcon from "src/components/ListItemIcon";
import ModulEnum from "src/enums/ModulEnum";
import { isVisible } from "src/utils/formAuthHelper";
export interface MenuItem {
    key: any;
    text: string;
    icon?: JSX.Element;
    authCode?: string;
    modul?: ModulEnum;
}
interface ButtonMenuProps extends ButtonProps {
    menuItems: Array<MenuItem>;
    onItemClick?: (e: MenuItem) => Promise<boolean>;
    loading?: boolean
}
const ButtonMenu = (_props: ButtonMenuProps): JSX.Element => {

    const { menuItems, onItemClick, ...props } = _props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <Button
                {...props}
                fullWidth={!(props?.fullWidth === false)}
                aria-controls={open ? props.id + '-menu-button' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={(e) => {
                    setAnchorEl(e.currentTarget);
                }}
                endIcon={<KeyboardArrowDownIcon />}
                loading={props.loading}
            >
                {props.children}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={(e) => {
                    handleClose()
                }}
                MenuListProps={{
                    'aria-labelledby': props.id + '-menu-button'
                }}
            >
                {
                    menuItems.map((m, i) => {
                        if (!isVisible(m.authCode, m.modul))
                            return <></>
                        return (
                            <MenuItem
                                key={m.key}
                                onClick={(e) => {
                                    onItemClick(m)
                                }}
                            >
                                {m.icon
                                    ?
                                    <ListItemIcon>
                                        {m.icon}
                                    </ListItemIcon>
                                    : ""
                                }

                                <ListItemText>
                                    {m.text}
                                </ListItemText>
                            </MenuItem>
                        )
                    })
                }

            </Menu>
        </>
    )
}

export default ButtonMenu;